module.exports = {
  IMMEDIATELY: 'immediately',
  FIRST_VISIT: 'first_visit'
}
